import {
  LOADING_USER,
  STORE_USER,
  STORE_USER_ERROR,
  USER_EXPIRED,
  USER_SIGNED_OUT
} from '../Types/types'
import {initialState} from "./paginationReducer";

export interface initialState {
  user: null,
  isLoadingUser: false
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state: initialState = {user: null, isLoadingUser: false}, action: any) {
  switch (action.type) {
    case STORE_USER:
      return {
        ...state,
        isLoadingUser: false,
        user: action.payload
      }
    case LOADING_USER:
      return {
        ...state,
        isLoadingUser: true
      }
    case USER_EXPIRED:
    case STORE_USER_ERROR:
    case USER_SIGNED_OUT:
      return {
        ...state,
        user: null,
        isLoadingUser: false
      }
    default:
      return state
  }
}